export const letters = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
];

export const capital_letters = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

export const allowedKeys = ["Backspace", "Tab", "+"];

export var Total_Food_Values = {
  Fat: 70,
  protein: 75,
  carbo: 500,
  total: 645,
};

export const countriesList = [
  {
    label: "Canada",
    value: "CA",
    abbrev: "CAN",
    currency_symbol: "$",
    phone_code: "c_+1",
  },
  {
    label: "Australia",
    value: "AU",
    abbrev: "AUS",
    currency_symbol: "$",
    phone_code: "c_+61",
  },
  {
    label: "United Kingdom",
    value: "UK",
    abbrev: "UK",
    currency_symbol: "£",
    phone_code: "c_+44",
  },
  {
    label: "New Zealand",
    value: "NZ",
    abbrev: "NZ",
    currency_symbol: "$",
    phone_code: "c_+64",
  },
  {
    label: "European Union",
    value: "EU",
    abbrev: "EUR",
    currency_symbol: "€",
    phone_code: "c_NA",
  },
  {
    label: "India",
    value: "IN",
    abbrev: "IND",
    currency_symbol: "₹",
    phone_code: "c_+91",
  },
];
